import {SEARCH} from "../constants/routes";

const getUrlHasPagination = (params, page, perPage, apiUrl) => {
  let url = "?";
  for (const param in params) {
    if (params[param] !== null && params[param] !== "") {
      url = url + `${param}=${params[param]}&`;
    }
  }
  return `${apiUrl}${url}page=${page}&per_page=${perPage}`;
};

const getUrl = (params, apiUrl) => {
  let url = "?";
  for (const key in params) {
    if (params[key] !== null && params[key] !== "") {
      url = url + `${key}=${params[key]}&`;
    }
  }
  url = url.slice(0, -1);
  return `${apiUrl}${url}`;
};

const getSearchBackUrl = (params, type = '', backRouter = SEARCH) => {
  let url = backRouter + `?`;
  if (type !== '') {
    url += `type=${type}&`;
  }
  for (const key in params) {
    let value = params[key]
    if(typeof params[key] === 'string'){
      value = params[key].trim()
    }
    if (value !== null && value !== "") {
      url += `${key}=${value}&`;
    }
  }
  url = url.slice(0, -1);
  return url;
};

const getNameFromPreSignedUrl = (url) => {
  return url.match(/\/([^/?]+)(?=\?|$)/)[1]
}

export { getUrlHasPagination, getUrl, getSearchBackUrl, getNameFromPreSignedUrl };
